import { createApp } from 'vue'
import { createPinia } from 'pinia' // 1. استيراد Pinia
import './style.css' // <--- هذا السطر هو المحرك للـ Tailwind
import App from './App.vue'
import router from './router'

const app = createApp(App)
const pinia = createPinia() // 2. إنشاء الكائن

app.use(pinia)   // 3. يجب أن يأتي قبل الروتر والمكونات
app.use(router)
window.addEventListener('error', (event) => {
    // إذا فشل تحميل ملف JS/CSS (Chunk load error)
    if (event.message.includes('Loading chunk') || /.*\.js|css/.test(event.message)) {
        console.warn("فشل تحميل ملف، سيتم إعادة التحميل...");
        // التأكد من عدم التكرار السريع جداً
        const lastReload = localStorage.getItem('last_reload');
        if (!lastReload || Date.now() - lastReload > 5000) {
            localStorage.setItem('last_reload', Date.now());
            window.location.reload(true);
        }
    }
}, true); // لاحظ إضافة true هنا لالتقاط الأخطاء في مرحلة الـ Capturing

app.mount('#app')